// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "./assets/css/bootstrap.min.css"
import "./assets/css/reset.css"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import config from './config'
import axios from 'axios'
import moment from 'moment';
import Print from 'vue-print-nb'
import common from'../commonFunction/common.js'
//引入图片查看器
import Viewer from 'v-viewer'
import 'babel-polyfill'
import 'viewerjs/dist/viewer.css'
import Clipboard from 'clipboard';
import $ from 'jquery'
import '../static/ueditor/ueditor.config'
import '../static/ueditor/ueditor.all.min'
import '../static/ueditor/lang/zh-cn/zh-cn'
import '../static/ueditor/ueditor.parse.min'
import htmlToPdf from '../src/service/htmlToPdf.js'

Vue.use(htmlToPdf);
Vue.use(ElementUI)
Vue.use(Print); //注册
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Vue.prototype.config = config
Vue.prototype.$http=axios
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.prototype.Clipboard=Clipboard
Vue.prototype.common = common
Vue.filter("dateFormat", function(value,format) {
  return value?moment(value).format(format):'';
});


router.beforeEach((to,from,next)=>{
  if(to.matched.length==0){
    next({path:'/'})
  }else{
    next()
  }
})



// http请求拦截器
axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})


// http响应拦截器
axios.interceptors.response.use(data => {// 响应成功关闭loading
  if (data.data.statusCode == 8) {
    router.push('/')
  } else {
    return data
  }
}, error => {
  return Promise.reject(error)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js